import { AnnotationSharedClassNames, BlockAnnotationSharedClassNames } from '@atlaskit/editor-common/styles';
export var getAnnotationViewClassname = function getAnnotationViewClassname(isUnresolved, hasFocus, isHovered) {
  if (!isUnresolved) {
    return;
  }
  if (hasFocus) {
    return AnnotationSharedClassNames.focus;
  }
  if (isHovered) {
    return AnnotationSharedClassNames.hover;
  }
  return AnnotationSharedClassNames.blur;
};
export var getBlockAnnotationViewClassname = function getBlockAnnotationViewClassname(isUnresolved, hasFocus) {
  if (!isUnresolved) {
    return;
  }
  return hasFocus ? BlockAnnotationSharedClassNames.focus : BlockAnnotationSharedClassNames.blur;
};